import { render, staticRenderFns } from "./MenuRoute.vue?vue&type=template&id=5de2f718&scoped=true&"
import script from "./MenuRoute.vue?vue&type=script&lang=js&"
export * from "./MenuRoute.vue?vue&type=script&lang=js&"
import style0 from "./MenuRoute.vue?vue&type=style&index=0&id=5de2f718&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de2f718",
  null
  
)

export default component.exports